<template>
    <element class="main-sidebar" :style="[!show ? {width:'0px'}:{}]">
      <transition name="el-zoom-in-center">
        <div v-show="show">
          <element>
              <element>
                <div class="aside-link-title">{{topMenuTitle}}</div>
              </element>
              <el-tree
                :data="subMenuData"
                :props="defaultProps"
                accordion
                @node-click="handleNodeClick">
              </el-tree>
          </element>
        </div>
      </transition>
      <div>
          <element class="pro-bar-btnwrap" :class="[{on: !show}]" @click="show=!show">
            <div class="pro-bar-btn " :class="[!show? 'pro-bar-btn-left':'pro-bar-btn-right']">
              <span></span>
            </div>
          </element>
      </div>
    </element>    
</template>
<script>
export default {
  data() {
    return {
      show: true,
      defaultProps: {},
      // subMenuData: []
      // subMenuData: [{
      //     label: '总览'
      //   }, {
      //     label: '用户中心',
      //     key: 'user',
      //     children: [
      //       {
      //         label: '用户管理',
      //         key: 'user'
      //       },
      //       {
      //         label: '功能权限',
      //         key: 'setting'
      //       },
      //       {
      //         label: '登录日志'
      //       },
      //       {
      //         label: '当前账户'
      //       }
      //     ]
      //   }, {
      //     label: '系统配置',
      //     children: [{
      //       label: '公司地址配置',
      //     }, {
      //       label: '参数配置',
      //     }]
      //   }]
    };
  },
  watch: {
    '$route.path' : function (newVal, oldVal) {
      if(newVal.split('/')[2] != oldVal.split('/')[2]) {
        this.show = true
      }
    }
  },
  props: {
    value: {
      type: Array
    },
    topMenuTitle: {
      type: String
    },
    root: {
      type: String
    },
    nodeClick: {
      type: Function
    }
  },
  computed: {
    subMenuData: function () {
      return this.parseMenu(this.value)
    }
  },

  methods: {
    handleNodeClick(data) {
      let link = data.link || ""

      this.$router.push(
        {
          path: this.root + link
        }
      )
    },
    parseMenu(val) {
      let ret = [];
      for (let key in val) {
        let item = val[key];
        let menuObject = {
          label: item.title,
          link: item.link
        };
        if (
          typeof item.submenus == "object" &&
          item.submenus[0].title != null
        ) {
          menuObject.children = this.parseMenu(item.submenus);
        }
        ret.push(menuObject);
      }
      return ret;
    }
  }
};
</script>

<style module v-if="show">
  .color-text{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/SubMenu.vue